import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import CardTable from "components/CardTable/CardTable";
import { columns_f } from "./columns_f";
import RegularButton from "components/CustomButtons/Button";
import { useDispatch, useSelector } from "react-redux";
import { ModalV2 } from "components/Modal/ModalV2";
import { handleNotesModal } from "redux/actions/routesStatus/routesStatusAction";
import NotesIcon from "@material-ui/icons/Notes";
import { Add } from "@material-ui/icons";
import { deselectNote } from "redux/actions/routesStatus/routesStatusAction";
import { useToggle } from "hooks/useToggle";
import { useTableRoutesConfig } from "views/RoutesStatus/hooks";
import { getSgc } from "redux/actions/sgc/sgcActions";
import { assignSGC } from "redux/actions/routesStatus/routesStatusAction";
import { useSearch } from "hooks/useSearch";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { LiquidationForm } from "views/Liquidations/LiquidationForm";
import { FormEndownmentsAccount } from "./FormEndownmentsAccount";
import { setNewNote } from "redux/actions/routesStatus/routesStatusAction";
import { removeAllNotes } from "redux/actions/routesStatus/routesStatusAction";
import { DelCauses } from "./DelCauses";
import { formatNumber } from "helpers/getNumberFormats";

export const EndowmentsAccountInfo = ({ block, submit, searchType }) => {
  // const notes = useSelector((state) => notesSelector(state));
  const { sgc } = useSelector(({ sgc }) => sgc);
  const [selectSgc, setSelectSgc] = useState("");
  const { id } = useParams();
  const handleSGC = (e, v) => {
    const value = v ? v : "";
    setSelectSgc(value);
  };
  const { stationsList } = useSelector(({ companies }) => companies);
  const {
    modalNote,
    settlement,
    configNotes: { page, pageSize, sorted, filtered },
  } = useSelector(({ routesStatus }) => routesStatus);
  const { unit } = settlement;
  const isPortable = unit.priceType === "PORTATIL";
  const isManual = settlement.routes.end.isManual === 1 ? true : false
  const { isLoadingComp } = useSelector(({ search }) => search);
  const [cilCount, setCilCount] = useState(0);
  const { setSnackbar } = useSearch();
  const [openDel, setOpenDel] = useToggle();
  // const total = settlement?.routes?.end?.endowments?.flowmeter - settlement?.routes?.start?.endowments?.flowmeter

  const {
    handleFilter,
    handlePage,
    handlePageSize,
    handleSort,
  } = useTableRoutesConfig("configNotes");
  const dispatch = useDispatch();
  const [open, setOpen] = useToggle();
  const [sgcLabel, setSgcLabel] = useState("");
  const handleClose = () => {
    dispatch(deselectNote());
    dispatch(setNewNote());
    dispatch(handleNotesModal());
  };

  const submitNewNote = () => {
    // dispatch(setNewNote());
    dispatch(handleNotesModal());
  };

  const handleRemoveNote = () => {
    dispatch(removeAllNotes());
    setOpenDel();
  };
  useEffect(() => {
    setSgcLabel(settlement?.fillingOrder?.fillingStation);
  }, [settlement?.fillingOrder]);

  useEffect(() => {
    sgc.length === 0 && dispatch(getSgc(stationsList));
  }, []);

  useEffect(() => {
    if (settlement.notes.length > 0) {
      let counter = 0;
      settlement.notes
        .filter((nt) => !nt.deleted)
        .map((note) => {
          counter += note.quantity;
        });
      setCilCount(formatNumber({input: counter}));
    } else {
      setCilCount(0);
    }
  }, [settlement.notes]);

  return (
    <>
      <Grid item xs={12}>
        <CardTable
          hasHeader
          title={`Notas: ${
            settlement?.notes?.filter((nt) => !nt.deleted).length
          } / ${isPortable ? "Cilindros" : "Litros"} ( ${cilCount} )`}
          icon={<NotesIcon />}
          columns={columns_f}
          data={
            settlement?.notes
              .filter((note) => !note.deleted)
              .map((noteM, idx) => {
                return {
                  ...noteM,
                  position: idx + 1,
                };
              }) || []
          }
          rowText="Notas"
          hasControl
          blockBtn
          page={page}
          pageSize={settlement?.notes?.length + 2 || 2}
          sorted={sorted}
          filtered={filtered}
          onFilteredChange={handleFilter}
          onPageSizeChange={handlePageSize}
          onPageChange={handlePage}
          onSortedChange={handleSort}
          // thWidth
          pageSizeAuto
          controls={
            <>
              {!searchType && (
                <>
                  {settlement && settlement.isDeleteNotes && (
                    <RegularButton
                      size="sm"
                      color="info"
                      tooltip="Eliminar Notas"
                      onClick={setOpenDel}
                    >
                     Eliminar Notas
                    </RegularButton>
                  )}
                  <RegularButton
                    size="sm"
                    round
                    justIcon
                    color="info"
                    tooltip="Crear Nota"
                    onClick={submitNewNote}
                  >
                    <Add style={{ margin: 0 }} />
                  </RegularButton>
                </>
              )}
            </>
          }
        />
      </Grid>
      <ModalV2 open={modalNote} onClose={handleClose} title="Notas" toRight>
        <FormEndownmentsAccount block={block} close={handleClose} isNewNote/>
      </ModalV2>
      <ModalV2 open={open} onClose={setOpen} toRight title="Agregar Notas">
        <LiquidationForm onClose={handleClose} />
        {/* <SGCForm onClose={setOpen} /> */}
      </ModalV2>
      <ModalV2
        open={openDel}
        onClose={setOpenDel}
        title="Seguro que desea eliminar las Notas?"
        justConfirm
      >
        {/* <RegularButton color="info" fullWidth onClick={handleRemoveNote}>
          confirmar
        </RegularButton>
        <RegularButton color="transparent" fullWidth onClick={setOpenDel}>
          cancelar
        </RegularButton> */}
        <DelCauses onClose={setOpenDel} notes={settlement?.notes}/>
      </ModalV2>
    </>
  );
};
